import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faQuoteRight,
  faEquals,
  faQuestion,
  faVectorSquare,
  faClone,
  faCalendar,
  faTimes,
  faCog
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faQuoteRight,
  faEquals,
  faQuestion,
  faVectorSquare,
  faClone,
  faCalendar,
  faTimes,
  faCog
);
